/**
 * DEV-2400, ADR-0064. Вкладка просмотра «глазами агента»: плашка, экраны входа
 * и завершения, тосты отказа. Начинают просмотр из CRM — модалка и пункт меню
 * живут там.
 */
export const impersonationMessages = {
  ru: {
    impersonation: {
      opening: 'Открываем кабинет агента…',
      linkInvalidTitle: 'Ссылка для просмотра недействительна',
      linkInvalidDescription:
        'Она одноразовая и действует минуту. Начните просмотр заново из раздела «Пользователи» в CRM.',
      endedTitle: 'Сеанс просмотра завершён',
      endedDescription: 'Вкладку можно закрыть — ваш сеанс в CRM не затронут.',
      closeTab: 'Закрыть вкладку',
      endMenu: 'Завершить просмотр',
      readOnlyToast: 'В режиме просмотра изменения недоступны',
      unsupportedToast: 'Этот раздел пока недоступен в режиме просмотра',
      banner: {
        viewingAs: 'Вы смотрите кабинет агента как',
        readOnly: 'Только просмотр',
        remaining: 'ещё {minutes} мин',
        end: 'Завершить',
      },
    },
  },
  en: {
    impersonation: {
      opening: 'Opening the agent cabinet…',
      linkInvalidTitle: 'The viewing link is invalid',
      linkInvalidDescription:
        'It works once and for one minute. Start viewing again from the Users section in the CRM.',
      endedTitle: 'Viewing session ended',
      endedDescription: 'You can close this tab — your CRM session is not affected.',
      closeTab: 'Close tab',
      endMenu: 'Stop viewing',
      readOnlyToast: 'Changes are not available in viewing mode',
      unsupportedToast: 'This section is not available in viewing mode yet',
      banner: {
        viewingAs: 'You are viewing the agent cabinet as',
        readOnly: 'Read-only',
        remaining: '{minutes} min left',
        end: 'Stop',
      },
    },
  },
  vn: {
    impersonation: {
      opening: 'Đang mở trang đại lý…',
      linkInvalidTitle: 'Liên kết xem không hợp lệ',
      linkInvalidDescription:
        'Liên kết chỉ dùng một lần trong một phút. Hãy bắt đầu xem lại từ mục «Người dùng» trong CRM.',
      endedTitle: 'Phiên xem đã kết thúc',
      endedDescription: 'Bạn có thể đóng tab này — phiên CRM của bạn không bị ảnh hưởng.',
      closeTab: 'Đóng tab',
      endMenu: 'Kết thúc xem',
      readOnlyToast: 'Không thể thay đổi trong chế độ xem',
      unsupportedToast: 'Mục này chưa khả dụng trong chế độ xem',
      banner: {
        viewingAs: 'Bạn đang xem trang đại lý dưới tên',
        readOnly: 'Chỉ xem',
        remaining: 'còn {minutes} phút',
        end: 'Kết thúc',
      },
    },
  },
}
